import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Box, Grid, Paper, Typography, Alert, AlertTitle, Card, CardActionArea, CardContent, Chip } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import ReportesIcon from '@mui/icons-material/Print'
import EstadoCajerosIcon from '@mui/icons-material/FactCheck'
import CajeroIcon from '@mui/icons-material/PointOfSale'
import TransaccionesIcon from '@mui/icons-material/MonetizationOn'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import BilleteraAdministrarIcon from '@mui/icons-material/AccountBalanceWallet'
import FuncionariosAdministrarIcon from '@mui/icons-material/Engineering'
import LockResetIcon from '@mui/icons-material/LockReset'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import SchoolIcon from '@mui/icons-material/School'
import BuildIcon from '@mui/icons-material/Build'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import BadgeIcon from '@mui/icons-material/Badge'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import AssessmentIcon from '@mui/icons-material/Assessment'
import ApartmentIcon from '@mui/icons-material/Apartment'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { withTranslation } from 'react-i18next'

const session = require('../../config/session')

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']

function saludoSegunHora() {
  const h = new Date().getHours()
  if (h < 12) return 'Buenos días'
  if (h < 19) return 'Buenas tardes'
  return 'Buenas noches'
}

function primerNombre() {
  const n = (session.getItem('nombres') || '').trim()
  if (!n) return ''
  return n.split(/\s+/)[0]
}

function fechaLarga() {
  const d = new Date()
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`
}

const HELP_VIDEOS = [
  {
    id: 'g_Ah-c-seoc',
    title: 'Cómo realizar depósitos',
    description: 'Inicio de sesión, recepción de billetes, manejo de rechazos, depósitos por sobre e impresión de comprobantes.',
    audience: 'Usuarios y operadores',
    Icon: SchoolIcon,
    color: '#6A9E2C',
  },
  {
    id: 'jiu0oitvjMQ',
    title: 'Módulo de mantenimiento',
    description: 'Ingreso con usuario técnico, estado de bóveda y sensores, bolsa de seguridad, prueba de impresora y reinicio controlado.',
    audience: 'Soporte técnico',
    Icon: BuildIcon,
    color: '#2C7FB2',
  },
  {
    id: 'kJ-fOp6gVsc',
    title: 'Módulo de administración',
    description: 'Auditoría de depósitos del día, navegación de transacciones, reimpresión de tickets y consulta de movimientos.',
    audience: 'Usuarios administrativos',
    Icon: AdminPanelSettingsIcon,
    color: '#B25A2C',
  },
  {
    id: 'ftKbYHzmA4o',
    title: 'Mantenimiento del lector de billetes',
    description: 'Apertura correcta del lector, revisión interna, verificación de atascos, ajuste de pestañas y reinstalación segura.',
    audience: 'Mantenimiento preventivo',
    Icon: SettingsApplicationsIcon,
    color: '#6A4FB2',
  },
  {
    id: 'BijAEI92or0',
    title: 'Apertura de bóveda y retiro de bolsa',
    description: 'Apertura segura de bóveda, retiro de bolsa, colocación de tapa, reinicio de contadores e impresión de comprobante.',
    audience: 'Transportadora autorizada',
    Icon: LocalShippingIcon,
    color: '#B22C5A',
  },
]

// Videos de ayuda del Sistema de Informacion (Smart Safe Control). Cada tarjeta se muestra
// solo si el usuario tiene el permiso correspondiente (check()). El grupo Reportes usa el
// mismo OR de permisos que el menu lateral de Reportes.
const HELP_VIDEOS_SSC = [
  {
    id: 'bGD9fEdEaW8',
    title: 'Creación de usuarios SSC',
    description: 'Aprende a crear y configurar usuarios con acceso al Sistema de Información de Smart Safe Control: creación de usuarios, asignación de roles, entidades, cajeros y configuración de permisos.',
    audience: 'Administración',
    Icon: PersonAddIcon,
    color: '#00897B',
    check: () => session.checkPermiso('acceder_usuarios_crear'),
  },
  {
    id: 'ZODcTRksHrM',
    title: 'Creación de funcionarios SSC',
    description: 'Aprende a crear y configurar funcionarios con acceso a los depositarios inteligentes: asignación de roles, cajeros, contraseñas y activación o desactivación de funcionarios.',
    audience: 'Administración',
    Icon: BadgeIcon,
    color: '#455A64',
    check: () => session.checkPermiso('acceder_funcionarios_crear'),
  },
  {
    id: 'B8IHNMznyz4',
    title: 'Creación de depositantes SSC',
    description: 'Aprende a crear y configurar depositantes autorizados para realizar depósitos en los depositarios inteligentes, incluyendo la asignación de cajeros y la administración de su acceso.',
    audience: 'Administración',
    Icon: GroupAddIcon,
    color: '#7E57C2',
    check: () => session.checkPermiso('acceder_depositantes_crear'),
  },
  {
    id: 'oh2lQaumiwE',
    title: 'Módulo Reportes SSC',
    description: 'Aprende a consultar transacciones, aplicar filtros, exportar información y generar los reportes de depósitos, Totales día, Totales recaudos, Saldos de cajeros y Operaciones para el seguimiento y control de la operación en Smart Safe Control.',
    audience: 'Reportes y control',
    Icon: AssessmentIcon,
    color: '#2C7FB2',
    check: () => (
      session.checkPermiso('acceder_reporte_totales_dia') ||
      session.checkPermiso('acceder_reporte_totales_recaudo') ||
      session.checkPermiso('acceder_reporte_cajeros_saldo') ||
      session.checkPermiso('acceder_reporte_totales_cuadre') ||
      session.checkPermiso('acceder_reporte_certificado_avance') ||
      session.checkPermiso('acceder_retiros') ||
      session.checkPermiso('acceder_operaciones') ||
      session.checkPermiso('acceder_depositos')
    ),
  },
  {
    id: 'H8-DNu9dR5g',
    title: 'Creación de entidades SSC',
    description: 'Aprende a crear y configurar entidades, administrar el Tag URL y crear roles con permisos personalizados para los usuarios del Sistema de Información.',
    audience: 'Administración',
    Icon: ApartmentIcon,
    color: '#B25A2C',
    check: () => session.checkPermiso('acceder_entidades'),
  },
]

const QUICK_LINKS = [
  { permiso: 'acceder_reporte_totales_dia', to: '/dashboard/totalesdia', label: 'Totales del día', desc: 'Resumen diario de recaudo', Icon: ReportesIcon, color: '#6A9E2C' },
  { permiso: 'acceder_reporte_totales_dia', to: '/dashboard/denominacionesfamilia', label: 'Denom. por familia', desc: 'Billetes vieja vs nueva por denominación', Icon: ReportesIcon, color: '#6A9E2C' },
  { permiso: 'acceder_cajeros_estados', to: '/dashboard/cajerosestados', label: 'Estados Cajeros', desc: 'Estado actual de los cajeros', Icon: EstadoCajerosIcon, color: '#2E7DD7' },
  { permiso: 'acceder_cajeros', to: '/dashboard/cajeros', label: 'Cajeros', desc: 'Administra tus dispositivos', Icon: CajeroIcon, color: '#E07A1F' },
  { permiso: 'acceder_depositos', to: '/dashboard/depositos', label: 'Depósitos', desc: 'Consulta transacciones', Icon: TransaccionesIcon, color: '#7E57C2' },
  { permiso: 'acceder_usuarios', to: '/dashboard/usuarios', label: 'Usuarios', desc: 'Gestiona los accesos', Icon: AccountBoxIcon, color: '#00897B' },
  { permiso: 'acceder_funcionarios', to: '/dashboard/funcionarios', label: 'Funcionarios', desc: 'Personal autorizado', Icon: FuncionariosAdministrarIcon, color: '#455A64' },
  { permiso: 'acceder_billetera_clientes', to: '/dashboard/billetera/clientes', label: 'Billetera', desc: 'Clientes y saldos', Icon: BilleteraAdministrarIcon, color: '#C2185B' },
  { permiso: 'acceder_dashboard', to: '/dashboard/soporte', label: 'Soporte', desc: 'Reporta fallas y haz seguimiento', Icon: SupportAgentIcon, color: '#2C7FB2' },
]

// Tarjeta de video reutilizable: MISMA interfaz grafica para las dos secciones de videos
// (Depositario Inteligente y Smart Safe Control). idx = posicion dentro de su propia lista.
function renderVideoCard(v, idx) {
  const VideoIcon = v.Icon
  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={v.id}>
      <Card
        sx={{
          borderRadius: '14px',
          overflow: 'hidden',
          height: '100%',
          backgroundColor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(0,0,0,0.06)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
          transition: 'transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 16px 32px rgba(0,0,0,0.14)',
            borderColor: v.color,
          },
        }}
      >
        <CardActionArea
          href={`https://youtu.be/${v.id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
        >
          <Box
            sx={{
              position: 'relative',
              aspectRatio: '16 / 9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(135deg, ${v.color} 0%, ${v.color}cc 60%, #1f1f1f 100%)`,
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                backgroundImage:
                  'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18) 0, transparent 30%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.12) 0, transparent 35%), repeating-linear-gradient(135deg, rgba(255,255,255,0.04) 0 10px, transparent 10px 20px)',
                pointerEvents: 'none',
              },
              '&:hover .home-video-play': {
                transform: 'scale(1.08)',
                opacity: 1,
              },
            }}
          >
            <VideoIcon sx={{ fontSize: 72, color: '#fff', opacity: 0.85, filter: 'drop-shadow(0 6px 14px rgba(0,0,0,0.25))', position: 'relative' }} />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.45) 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PlayCircleOutlineIcon
                className="home-video-play"
                sx={{
                  fontSize: 64,
                  color: '#fff',
                  opacity: 0.92,
                  filter: 'drop-shadow(0 6px 14px rgba(0,0,0,0.4))',
                  transition: 'transform 220ms ease, opacity 220ms ease',
                }}
              />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: 10,
                left: 10,
                width: 28,
                height: 28,
                borderRadius: '9px',
                backgroundColor: '#fff',
                color: v.color,
                fontWeight: 700,
                fontSize: '0.85rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 10px rgba(0,0,0,0.22)',
              }}
            >
              {idx + 1}
            </Box>
          </Box>
          <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 0.8 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Chip
                label={v.audience}
                size="small"
                sx={{
                  backgroundColor: `${v.color}1A`,
                  color: v.color,
                  fontWeight: 600,
                  fontSize: '0.7rem',
                }}
              />
            </Box>
            <Typography sx={{ fontWeight: 700, color: '#222', lineHeight: 1.25, fontSize: '0.98rem' }}>
              {v.title}
            </Typography>
            <Typography variant="caption" sx={{ color: '#555', lineHeight: 1.45 }}>
              {v.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  )
}

class HomePage extends Component {
  render() {
    const { t } = this.props
    const nombre = primerNombre()
    const saludo = saludoSegunHora()
    const fecha = fechaLarga()
    const debeCambiarPassword = session.getItem('changePassword')

    const links = QUICK_LINKS.filter((l) => session.checkPermiso(l.permiso))
    // Videos del Sistema de Informacion visibles segun los permisos del usuario
    const sscVideos = HELP_VIDEOS_SSC.filter((v) => v.check())

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/Pegasus1.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(245,247,250,0.92) 0%, rgba(245,247,250,0.55) 55%, rgba(245,247,250,0.20) 100%)',
            pointerEvents: 'none',
          }}
        />

        <Box
          sx={{
            position: 'relative',
            mt: { xs: '90px', md: '110px' },
            ml: { xs: '24px', md: '300px' },
            mr: { xs: '24px', md: '40px' },
            pb: 6,
            zIndex: 1,
            animation: 'homeFadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
            '@keyframes homeFadeIn': {
              from: { opacity: 0, transform: 'translateY(12px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          <Typography
            variant="overline"
            sx={{ color: '#6A9E2C', fontWeight: 700, letterSpacing: '0.12em' }}
          >
            {fecha}
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: '#222',
              lineHeight: 1.1,
              mt: 0.5,
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.6rem' },
            }}
          >
            {saludo}{nombre ? `, ${nombre}` : ''}
          </Typography>

          <Typography variant="body1" sx={{ color: '#555', mt: 1, maxWidth: '640px' }}>
            {t('window_home_lbl_bienvenida')} al panel de control. Selecciona una opción para comenzar o utiliza el menú lateral.
          </Typography>

          {debeCambiarPassword && (
            <Alert
              severity="warning"
              variant="filled"
              icon={<LockResetIcon />}
              sx={{
                mt: 3,
                borderRadius: '12px',
                boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                maxWidth: '720px',
              }}
            >
              <AlertTitle sx={{ fontWeight: 700 }}>Tu contraseña ha expirado</AlertTitle>
              Debes cambiarla desde <strong>Mi Cuenta → Opciones de cuenta</strong> y volver a iniciar sesión.
            </Alert>
          )}

          {links.length > 0 && (
            <Box sx={{ mt: 4 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: '#333', mb: 2 }}
              >
                Accesos rápidos
              </Typography>

              <Grid container spacing={2}>
                {links.map(({ to, label, desc, Icon, color }) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={to}>
                    <Paper
                      component={Link}
                      to={to}
                      elevation={0}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        p: 2,
                        borderRadius: '14px',
                        textDecoration: 'none',
                        backgroundColor: 'rgba(255,255,255,0.92)',
                        backdropFilter: 'blur(6px)',
                        border: '1px solid rgba(0,0,0,0.06)',
                        transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                        '&:hover': {
                          transform: 'translateY(-3px)',
                          boxShadow: '0 12px 28px rgba(0,0,0,0.12)',
                          borderColor: color,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: `${color}1A`,
                          color: color,
                          flexShrink: 0,
                        }}
                      >
                        <Icon />
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                          sx={{ fontWeight: 700, color: '#222', lineHeight: 1.2 }}
                          noWrap
                        >
                          {label}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: '#666' }}
                          noWrap
                        >
                          {desc}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* Videos de ayuda - visibles para todos */}
          <Box sx={{ mt: 5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 0.5 }}>
              <OndemandVideoIcon sx={{ color: '#6A9E2C' }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#333' }}>
                Videos de ayuda · Depositario Inteligente
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ color: '#666', display: 'block', mb: 2 }}>
              Capacitaciones para usuarios, soporte técnico, administradores y transportadoras. Toca una tarjeta para abrir el video en YouTube.
            </Typography>

            <Grid container spacing={2}>
              {HELP_VIDEOS.map((v, idx) => renderVideoCard(v, idx))}
            </Grid>
          </Box>

          {/* Videos de ayuda - Sistema de Informacion (segun permisos del usuario) */}
          {sscVideos.length > 0 && (
            <Box sx={{ mt: 5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 0.5 }}>
                <OndemandVideoIcon sx={{ color: '#2C7FB2' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#333' }}>
                  Videos de ayuda · Smart Safe Control
                </Typography>
              </Box>
              <Typography variant="caption" sx={{ color: '#666', display: 'block', mb: 2 }}>
                Capacitaciones del Sistema de Información según tus permisos. Toca una tarjeta para abrir el video en YouTube.
              </Typography>

              <Grid container spacing={2}>
                {sscVideos.map((v, idx) => renderVideoCard(v, idx))}
              </Grid>
            </Box>
          )}

          {links.length === 0 && !debeCambiarPassword && (
            <Paper
              sx={{
                mt: 3,
                p: 3,
                borderRadius: '14px',
                backgroundColor: 'rgba(255,255,255,0.92)',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                maxWidth: '640px',
              }}
              elevation={0}
            >
              <HomeIcon sx={{ color: '#6A9E2C', fontSize: 36 }} />
              <Typography variant="body2" sx={{ color: '#444' }}>
                Utiliza el menú lateral para navegar por las opciones disponibles para tu rol.
              </Typography>
            </Paper>
          )}
        </Box>
      </div>
    )
  }
}

export default withTranslation()(HomePage)
